import React from 'react';
import { defineMessages } from 'react-intl';
import _ from 'lodash';
import ContextProvider from '../../components/ContextProvider/ContextProvider';
import OnlineProvider from '../../components/OnlineProvider/OnlineProvider';
import notAuthorized from '../not-authorized';
import LessonDetails from './LessonDetails';

import {
  getLessonBySlug,
  resetTextNotes,
  resetVideoNotes,
} from '../../actions/lessonDetails';
import { reset } from '../../actions/courseDetails';
import { getTranscodingJobs } from '../../actions/transcodingJobs';
import { isIOS, isIOSServer, ssrRequest } from '../../helpers';
import isLoggedIn from '../../helpers/checkAuth';

const messages = defineMessages({
  lessonTitle: {
    id: 'LessonDetails.lessonTitle',
    defaultMessage: 'lesson',
    description: 'Title appendix displayed in lesson details',
  },
});

async function action(context) {
  const {
    store,
    params,
    fetch,
    query,
    intl: { formatMessage },
    cloudfrontUrl,
    userAgent,
  } = context;

  const { lessonSlug } = params;

  const { auth } = store.getState();

  await store.dispatch(reset());
  await store.dispatch(resetTextNotes());
  await store.dispatch(resetVideoNotes());

  const promises = [];

  promises.push(async () =>
    ssrRequest({
      getAction: getLessonBySlug.bind(this, lessonSlug),
      store,
      fetch,
      context,
    }),
  );

  if (isLoggedIn(auth)) {
    promises.push(async () =>
      ssrRequest({
        getAction: getTranscodingJobs.bind(this, {
          page: 1,
          perPage: 10,
          lessonId: lessonSlug,
          'status[0]': 'pending',
          'status[1]': 'processing',
        }),
        store,
        fetch,
        context,
      }),
    );
  }

  const requests = await Promise.all(promises.map(promise => promise()));

  const notAuthorizedReq = _.find(
    requests,
    item => _.get(item, 'status') === 401,
  );
  const notFoundReq = _.find(requests, item => _.get(item, 'status') >= 400);

  if (notAuthorizedReq) {
    return notAuthorized(context);
  }

  if (notFoundReq) {
    return notFoundReq;
  }

  const { lessonDetails } = store.getState();

  const title = `${_.get(lessonDetails, 'lesson.name', '')} - ${formatMessage({
    ...messages.lessonTitle,
  })}`;

  let imageUrl = _.get(lessonDetails, 'lesson.preview.path');
  if (imageUrl) {
    imageUrl = `${cloudfrontUrl}/${imageUrl}`;
  }

  return {
    chunks: ['lesson-details'],
    title,
    component: (
      <ContextProvider context={context}>
        <OnlineProvider path={context.path}>
          <LessonDetails
            data={{}}
            title={title}
            query={query}
            isIOS={isIOSServer(userAgent) || isIOS()}
            searchSessionId={query.searchSessionId}
          />
        </OnlineProvider>
      </ContextProvider>
    ),
  };
}

export default action;
